export default {"src":"/_next/static/media/fiveKg_24.54292a0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};